// extracted by css-extract-rspack-plugin
export default {"container":"Jykpu","headerOpened":"GqteO","suggestionEditor":"_pgoO","suggestionEditorOnlyNew":"SRdNA","suggestionHeader":"f3iM8","suggestionHeaderCollapsed":"N_Z6K"};